import { render, staticRenderFns } from "./KickUserCardModal.vue?vue&type=template&id=6670ac1f&"
import script from "./KickUserCardModal.vue?vue&type=script&lang=js&"
export * from "./KickUserCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports